const messages = {
  fleetWithOptions:
    "You cannot select fleet if you have selected options",
  addProduct: "Your product has been added to the cart.",
  addProducts: "Your products have been added to the cart.",
  profileSaved: "Your profile data has been saved",
  canAddProduct: "You do not have enough points.",
  customerNumberSaved: "Customer number saved",
  customerNumberExist: "Customer number already exists",
  complaintForm: "Your request has been accepted. Please wait for a response",
  openHourSaved: "Opening hours have been saved",
  changeParentId:
    "You cannot change the branch with the parent customer number if it has subordinate branches.",
  requestSent: "The request has been sent",
  completeProfileRequired:
    "You must complete your profile to 100% to continue shopping in the store.",
  accessDenied: "Access denied",
  incomplete_address: "The address is incomplete. Please check it",
  waitMoment: "Please wait a moment",
  downloadFinished: "Download finished",
  selectOneField: "Select a field",
  noVoucher: "The voucher was not found",
  cannotAddCsNumber: "You cannot add a customer number.",
  messagesDeletedSuccess: "Messages were deleted.",
  messagesDeletedError: "Failed to delete messages.",
  fillProfile: "Fill out the profile to be able to download the certificate,",
  favoriteAdded: "Added to favorites.",
  favoriteRemoved: "Removed from favorites.",
};

export default {
  messages,
};
